import { Col, DatePicker, Form, Row } from 'antd'
import CustomSpin from '../../../../../../elements/CustomSpin'
import FormSectionTitle from '../../../../../../elements/FormSectionTitle'
import { rules, threeFormItemLayout } from '../../../../../../modules/FormItems'
import moment from 'moment'
import React from 'react'

function ActivityForm(props) {
  const { submitting } = props
  const { getFieldDecorator } = props.form

  return (
    <CustomSpin spinning={submitting}>
      <Form>
        <FormSectionTitle title={'Details'} />
        <Row>

          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Start'}>
              {getFieldDecorator('start', {
                initialValue: moment('01-01-2021'),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} placeholder="Start" />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'End'}>
              {getFieldDecorator('end', {
                initialValue: moment(),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} placeholder="End" />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomSpin>
  )
}

ActivityForm.propTypes = {}
ActivityForm.defaultProps = {
  selection: [],
}

export default Form.create()(ActivityForm)
